import { render, staticRenderFns } from "./alumni.vue?vue&type=template&id=24f383dc&"
import script from "./alumni.vue?vue&type=script&lang=js&"
export * from "./alumni.vue?vue&type=script&lang=js&"
import style0 from "./alumni.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports